import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';
import css from './FormDropdown.module.scss';
import { getDefaultVariation, getIsCoupleVariation } from '../../helpers';
import { useContext, useRef, useState, useEffect, useMemo, useCallback } from 'react';
import UserContext, { UserProfileContext } from '../../../../../common/utils/getContext';
import ReactDOM from 'react-dom';
import FromInputTitle from '../../FormFieldTitle/FormFieldTitle';
import { FieldError, FieldInfo } from '../../../../../hybrid/wrappers';
import DropdownMenu from '../components/DropdownMenu/DropdownMenu';
import { getInputStyles } from '../../form-input/helpers';
import { useWidgetTranslates } from '../../../../../common/utils/utils';
import { findOptionByValueId, getIdetify, searchFunction, useLoadOptions, validValue } from '../helpers';
import DropdownSwitcher from '../components/Elements/Elements';
import { t } from '../../../../../common/components/T';

const FormDropdown = (props) => {
    const inputRef = useRef();
    const pickerElement = useRef();
    const timeout = useRef();
    const {
        sorting = ['search', 'input', 'copy', 'clear', 'arrow'],
        setFormData,
        insertComponentInOptionBefore,
        insertComponentBefore = null,
        searchInputProps = {},
        handlers,
        options = [],
        multiple,
        variation,
        placeholder,
        compStyle = {},
        title,
        disabled,
        attribute,
        errors,
        hint,
        buttons = {},
        required,
        info,
        value,
        valueId,
        getOptions = {},
        isClear,
        selectedLimit = 2,
        limit = 999,
        isSearchable = true,
        formatter,
        maxMenuHeight = 273,
        selectAll,
        search,
        copy,
        absoluteSelectAll,
        customData,
        fixSearch = false
    } = props;

    // fixSearch = false
    // коли через getOptions в полі іде пошук елемента який знаходиться на іншій сторінці - вибираєш його - і потім клацаєш за межами дропдауна - елемент пропадає з поля, тому що список знов стає на перших 10 елементів, і name не підтягується
    const nextPageLink = useRef();

    const profileContext = useContext(UserProfileContext) || {};
    const { stylers, classes } = generateCompStylers(compStyle);
    const variationStyle = variation || getDefaultVariation(profileContext, title);

    const transl = useWidgetTranslates('form');
    const [menuIsOpen, openMenu] = useState(false);

    const isValueMultiple = useMemo(
        () => value && Array.isArray(value) && value?.map((opt) => getIdetify(opt))?.filter((opt) => opt !== undefined),
        [value]
    );
    const isValueId = useMemo(
        () => (multiple ? (isValueMultiple?.length ? isValueMultiple : valueId) : getIdetify(value) || valueId),
        [isValueMultiple, multiple, value, valueId]
    );
    const [val, setVal] = useState(isValueId);

    const [loading, setLoading] = useState(Boolean(getOptions?.url));
    const [getAllList, setGetAllList] = useState([]);
    const [getAllListFinded, setGetAllListFinded] = useState([]);
    const { listState, loadOptions, setList } = useLoadOptions(getOptions, loading, setLoading, nextPageLink, multiple);
    useEffect(() => {
        if (Boolean(getOptions?.url)) {
            setLoading(true);
            setList([]);
        }
    }, [getOptions?.url, setList]);
    const [findedList, findList] = useState([]);

    useEffect(() => {
        const merged = [
            ...(listState || []),
            ...getAllListFinded.filter((findedItem) => !listState.some((listItem) => listItem.value === findedItem.value))
        ];

        setGetAllList(merged);
    }, [listState, getAllListFinded]);

    // const list = useMemo(() => [...(options || []), ...(listState || [])], [listState, options]);
    const list = useMemo(
        () => [...(options || []), ...(fixSearch ? getAllList || [] : listState || [])],
        [fixSearch, listState, getAllList, options]
    );
    if (attribute == 'development') {
        console.log('getAllList', getAllList);
        console.log('listState', listState);
    }

    const [searchValue, setSearchValue] = useState('');

    const allList = useMemo(
        () => [
            ...((selectAll && multiple) || absoluteSelectAll
                ? [{ label: selectAll || absoluteSelectAll, value: '<SELECT_ALL>' }]
                : []),
            ...list
        ],
        [list, multiple, selectAll, absoluteSelectAll]
    );
    const optionsList = useMemo(() => (searchValue ? findedList : allList), [allList, findedList, searchValue]);
    const setOptionsList = searchValue ? findList : setList;
    const getValOption = useCallback(
        (val) => findOptionByValueId(val, findedList, allList, multiple),
        [allList, findedList, multiple]
    );
    const valueOption = !multiple || getValOption(val)?.length || !value ? getValOption(val) || value : value;

    const isFilled = multiple ? valueOption?.length : valueOption;

    const { userToken, lang } = useContext(UserContext);

    useEffect(() => {
        setVal(isValueId);
    }, [isValueId]);

    const openMenuFunc = useCallback(() => {
        if (!disabled) {
            openMenu(true);
            if (!getOptions?.preparedLoad) {
                loadOptions();
            }
            inputRef?.current?.focus();
        }
    }, [disabled, getOptions?.preparedLoad, loadOptions]);

    const handleClose = useCallback(() => {
        setSearchValue('');

        findList([]);

        openMenu(false);

        inputRef?.current?.blur();
    }, []);
    const toggleFunc = useCallback(() => {
        if (!disabled) {
            if (menuIsOpen) {
                handleClose();
            } else {
                openMenuFunc();
            }
        }
    }, [disabled, handleClose, menuIsOpen, openMenuFunc]);
    const inputHandler = (v) => {
        searchFunction(
            v,
            nextPageLink,
            setSearchValue,
            list,
            findList,
            timeout,
            getOptions,
            setLoading,
            userToken,
            lang,
            setGetAllListFinded
        );
    };
    const inputConfig = {
        value: searchValue,
        onChange: (e) => inputHandler(e.target.value),
        required,
        readOnly: !isSearchable,
        placeholder: '',
        disabled: Boolean(disabled) || false,
        className: classnames(css.input, classes.input, classes.onlyInputStyle),
        style: getInputStyles(stylers, errors, menuIsOpen, disabled, null),
        ...searchInputProps
    };
    const changeHandler = useCallback(
        (newValue, close) => {
            if (!disabled) {
                setVal(newValue);
                setFormData(attribute, getValOption(newValue));

                handlers?.onChange && handlers?.onChange(getValOption(newValue), attribute);
                handlers?.onChangeCustom && handlers?.onChangeCustom(getValOption(newValue), attribute);
                if (close) {
                    setSearchValue('');
                    findList([]);
                    handleClose();
                }
            }
        },
        [attribute, disabled, getValOption, handleClose, handlers, setFormData]
    );
    const allSelected = list?.length === val?.length;
    const selectHandler = (opt) => {
        if (multiple) {
            if (opt?.value === '<SELECT_ALL>') {
                if (allSelected) {
                    changeHandler([]);
                } else {
                    changeHandler(list?.map((o) => getIdetify(o)));
                }
            } else {
                if (validValue(multiple, val, opt)) {
                    changeHandler(val?.filter((o) => o !== getIdetify(opt)));
                } else {
                    const prev = val && Array.isArray(val) ? val : [];
                    changeHandler([...prev, getIdetify(opt)]);
                }
            }
            inputRef?.current?.focus();
        } else {
            changeHandler(getIdetify(opt), true);
        }
    };

    const dropdownButtons = useMemo(
        () => ({
            ...buttons,
            ...(isClear && isFilled
                ? {
                      clear: {
                          handler: () => {
                              changeHandler(multiple ? [] : false);
                          },
                          icon: 'cross-gt'
                      }
                  }
                : {}),
            arrow: {
                handler: (e) => {
                    e.stopPropagation();
                    toggleFunc();
                },
                icon: menuIsOpen ? 'angle-up-system' : 'angle-down-system'
            }
        }),
        [buttons, changeHandler, isClear, isFilled, menuIsOpen, multiple, toggleFunc]
    );
    const sorted = useMemo(() => {
        const notExisted = {
            search: !search,
            copy: !copy,
            clear: !dropdownButtons['clear']
        };
        return [
            ...sorting.filter((k) => !notExisted[k]),
            ...Object.keys(dropdownButtons).reduce((ac, k) => {
                if (sorting.includes(k)) return ac;
                return [...ac, k];
            }, [])
        ];
    }, [copy, dropdownButtons, search, sorting]);
    const { stylersClearBtn, classesClearBtn } = generateCompStylers(compStyle?.['clear'], 'ClearBtn');
    const { stylersArrowBtn, classesArrowBtn } = generateCompStylers(compStyle?.['clear'], 'ArrowBtn');
    return (
        <div
            key={attribute}
            style={stylers.wrapper}
            className={classnames(css.formGroup, css[variationStyle], classes.wrapper || {})}
            {...{ 'data-focused': menuIsOpen }}
        >
            {menuIsOpen
                ? ReactDOM.createPortal(
                      <DropdownMenu
                          loading={loading}
                          insertComponentInOptionBefore={insertComponentInOptionBefore}
                          limit={limit}
                          selectHandler={selectHandler}
                          val={val}
                          attribute={attribute}
                          multiple={multiple}
                          nativeOptionsList={options}
                          optionsList={optionsList}
                          searchValue={searchValue}
                          getOptions={getOptions}
                          handleClose={handleClose}
                          pickerElement={pickerElement}
                          transl={transl}
                          maxMenuHeight={maxMenuHeight}
                          formatter={formatter}
                          setOptionsList={setOptionsList}
                          nextPageLink={nextPageLink}
                          compStyle={compStyle}
                          selectAll={selectAll}
                          allSelected={allSelected}
                          customUpdatePosition={customData?.['customUpdatePosition']}
                      />,
                      document?.body
                  )
                : null}
            {!!title && !getIsCoupleVariation(variationStyle) ? (
                <FromInputTitle
                    errors={errors}
                    title={title}
                    compStyle={compStyle}
                    hint={hint}
                    required={required}
                    variationStyle={variationStyle}
                    isFilled={isFilled}
                />
            ) : null}
            <div
                ref={pickerElement}
                onClick={(e) => {
                    if (e.target.classList.contains('disable-parent-event') || e.target.closest('.disable-parent-event')) {
                        return;
                    }
                    e.stopPropagation();
                    toggleFunc();
                }}
                style={{
                    cursor: 'pointer',
                    ...(!disabled ? stylers.input : {}),
                    ...(errors && errors.length ? stylers.inputError : {}),
                    ...(menuIsOpen ? stylers.inputFocus : {}),
                    ...(disabled ? stylers.inputDisabled : {})
                }}
                className={classnames(
                    css[`${variationStyle}--formControl`],
                    { [css['no-border']]: stylers.input?.border === 'none' },
                    classes.input,
                    errors && errors.length && [css[`${variationStyle}--formControl--error`], classes.inputError],
                    menuIsOpen && [css[`${variationStyle}--formControl--focus`], classes.inputFocus],
                    disabled && !errors?.length && [css['formControl--disabled'], classes.inputDisabled]
                )}
            >
                <div
                    style={stylers.formControlContent}
                    className={classnames(css.formControlContent, classes.formControlContent)}
                >
                    {insertComponentBefore}
                    {sorted.map((keyword, index) => (
                        <DropdownSwitcher
                            {...props}
                            {...{
                                hint,
                                placeholder: placeholder || t('DropdownMenu-select', 'Выберите', 'widget', transl, 'form'),
                                required,
                                disabled,
                                title,
                                errors,
                                keyword,
                                previous: sorted[index - 1],
                                changeHandler,
                                variationStyle,
                                val,
                                isFilled,
                                menuIsOpen,
                                multiple,
                                selectedLimit,
                                valueOption,
                                formatter,
                                searchValue,
                                selectHandler,
                                variation,
                                inputConfig,
                                inputRef,
                                allSelected,
                                selectAll
                            }}
                            compStyle={{
                                ...compStyle,
                                clear: {
                                    ...(stylersClearBtn || {}),
                                    icon: {
                                        width: '18px',
                                        height: '18px',
                                        ...stylersClearBtn?.icon,
                                        className: classesClearBtn?.icon
                                    }
                                },
                                arrow: {
                                    ...(stylersArrowBtn || {}),
                                    icon: {
                                        width: '18px',
                                        height: '18px',
                                        ...stylersArrowBtn?.icon,
                                        className: classesArrowBtn?.icon
                                    }
                                }
                            }}
                            buttons={dropdownButtons}
                            key={`${attribute}_${keyword}`}
                        />
                    ))}
                </div>
            </div>
            {!!info && <FieldInfo compStyle={compStyle.info}>{info}</FieldInfo>}
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError compStyle={compStyle.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
        </div>
    );
};
export default FormDropdown;
